<script setup lang="ts">
import { IEventV2 } from "@/models/event";
import { PropType, onMounted, ref } from "vue";
import {
  homeOutline,
  enterOutline,
  peopleOutline,
  settingsOutline,
} from "ionicons/icons";

const props = defineProps({
  event: Object as PropType<IEventV2>,
});

const menuItems = ref([] as { name: string; icon: string; route: string }[]);

onMounted(() => {
  if (props.event) {
    menuItems.value = [
      {
        name: "Home",
        icon: homeOutline,
        route: "home",
      },
      {
        name: "Check-in",
        icon: enterOutline,
        route: "scan",
      },
      {
        name: "Visitors",
        icon: peopleOutline,
        route: "visitors",
      },
      {
        name: "Setup",
        icon: settingsOutline,
        route: "settings",
      },
    ];
  }
});
</script>

<template>
  <div class="event-sidebar">
    <div v-if="event">
      <img
        :src="event.image"
        alt="Event image"
        v-if="event.image && event.image !== ''"
      />
      <img alt="Event image" src="@/assets/background.png" v-else />

      <div style="display: none">Exhibiting</div>

      <div class="list-items">
        <div
          class="flex-desktop"
          style="align-items: center"
          v-for="(item, i) of menuItems"
          :key="i"
        >
          <router-link
            style="text-decoration: none; color: inherit"
            :to="item.route"
          >
            <ion-icon :icon="item.icon"></ion-icon>
            <span>{{ item.name }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.event-sidebar {
  height: calc(100vh - 72px);
  width: 300px;
  background-color: #ffffff;
  -webkit-box-shadow: 3px 0px 10px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 3px 0px 10px 0px rgba(0, 0, 0, 0.3);
  z-index: 10;
}

.list-items {
  margin-top: 20px;
}

.list-items div {
  height: 40px;
  padding-left: 20px;
  cursor: pointer;
}

.list-items div ion-icon {
  margin-right: 10px;
}

.list-items div:has(> a.router-link-exact-active) {
  border-left: solid 3px black;
}

a.router-link-exact-active {
  font-weight: 600;
}
</style>
